import { BigNumber as EthersBN } from 'ethers';

const meta: any = { version: 1, createdAt: new Date().toISOString() };
const calls: Record<string, unknown> = {};
const snapshot: any = { persistentStore: {} };

function serialize(value: any): any {
  if (EthersBN.isBigNumber && EthersBN.isBigNumber(value)) {
    return { __type: 'BigNumber', value: value.toString() };
  }
  if (Array.isArray(value)) {
    // Detect ethers tuple/struct array with named properties
    const namedKeys = Object.keys(value).filter((k) => isNaN(Number(k)));
    if (namedKeys.length > 0) {
      const props: any = {};
      for (const k of namedKeys) props[k] = serialize((value as any)[k]);
      return { __type: 'EthersStruct', array: value.map(serialize), props };
    }
    return value.map(serialize);
  }
  if (value && typeof value === 'object') {
    const out: any = {};
    for (const [k, v] of Object.entries(value)) out[k] = serialize(v);
    return out;
  }
  return value;
}

export function recordStaticCall(key: string, value: unknown): void {
  calls[key] = serialize(value);
}

export function exportStaticCacheFile(filename = 'df-read-cache.json'): void {
  const blob = new Blob([JSON.stringify({ meta, calls, snapshot }, null, 2)], { type: 'application/json' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function recordPersistentStoreSnapshot(data: {
  touchedPlanetIds?: string[];
  revealedCoords?: any[];
  claimedCoords?: any[];
  chunks?: any[];
  homeLocations?: any[];
}): void {
  snapshot.persistentStore = serialize(data);
}

